/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Ikhwirtschaft13Inputs */

const en__field_enum_ikhwirtschaft13 = /** @type {(inputs: _Field_Enum_Ikhwirtschaft13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`02 - Wirtschaftswissenschaften`)
};

const de__field_enum_ikhwirtschaft13 = /** @type {(inputs: _Field_Enum_Ikhwirtschaft13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`02 - Wirtschaftswissenschaften`)
};

/**
* | output |
* | --- |
* | "02 - Wirtschaftswissenschaften" |
*
* @param {_Field_Enum_Ikhwirtschaft13Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_ikhwirtschaft13 = /** @type {((inputs?: _Field_Enum_Ikhwirtschaft13Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Ikhwirtschaft13Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_ikhwirtschaft13(inputs)
	return de__field_enum_ikhwirtschaft13(inputs)
});
export { _field_enum_ikhwirtschaft13 as "_field_enum_IKHWIRTSCHAFT" }